// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wSuOs","title":"Info_title__1SDvB","selects":"Info_selects__21yHQ","requiredAsterisk":"Info_requiredAsterisk__2PSyz"};